import $ from "jquery";
window.jQuery = $;
window.$ = $;

export default function initPersonMovement() {
  const isPresent = document.querySelector(".single-person-wrap");
  if (!isPresent) {
    return;
  }

  const people = document.querySelectorAll(".single-person-wrap");

  people.forEach((person) => {
    person.addEventListener("mousemove", (e) => {
      var objLeft = $(person).offset().left;
      var objTop = $(person).offset().top;

      var objCenterX = objLeft + $(person).width() / 2;
      var objCenterY = objTop + $(person).height() / 2;

      const x = e.pageX - objCenterX;
      const y = e.pageY - objCenterY;

      person.style.transform = `translate(${x / 5}px,${y / 5}px)`;
    });

    person.addEventListener("mouseleave", (e) => {
      person.style.transform = `translate(${0}px,${0}px)`;
    });
  });
}
